module.exports = __webpack_public_path__ + "media/images/logo-6a47fd7075813c5a09b8eeb43797e8e5.png";